import { AxiosResponse } from "axios";
import { axiosRequest } from "../../axios/axios.config";
import LoginService from "pages/login/login.service";
import {
  IConferenciaVenda,
  ISku,
  ISkuValidado,
  ItensPedidoAConferir,
} from "./conferencia.model";

const ConferenciaService = () => {
  const path = "/conferenciavenda";
  const loginService = LoginService();

  return {
    getConferir(
      uuidPedidoVenda: string
    ): Promise<AxiosResponse<IConferenciaVenda>> {
      return axiosRequest.get(
        `${path}/conferir/${uuidPedidoVenda}`,
        { headers: loginService.getHeaders() }
      );
    },

    getSkuCodigoBarra(
      codigoBarra: string,
      uuidPedidoVenda: string
    ): Promise<AxiosResponse<ISkuValidado>> {
      return axiosRequest.get(`${path}/leitor/${codigoBarra}`, {
        headers: loginService.getHeaders(),
        params: { uuidPedidoVenda },
      });
    },

    salvarConferencia(
      conferencia: IConferenciaVenda
    ): Promise<AxiosResponse<void>> {
      return axiosRequest.post(`${path}/salvar`, conferencia, {
        headers: loginService.getHeaders(),
      });
    },

    getSkuCodigoOuNome(codigoOuNome = " "): Promise<AxiosResponse<ISku[]>> {
      return axiosRequest.get(`/sku/buscar`, {
        headers: loginService.getHeaders(),
        params: { codigoNome: codigoOuNome },
      });
    },

    validaSku(
      uuidPedidoVenda: string,
      sku: ISku
    ): Promise<AxiosResponse<ISkuValidado>> {
      return axiosRequest.post(`${path}/addSkuSelecionado`, sku, {
        headers: loginService.getHeaders(),
        params: { uuidPedidoVenda },
      });
    },

    getItensPedido(
      uuidPedidoVenda: string
    ): Promise<AxiosResponse<ItensPedidoAConferir>> {
      return axiosRequest.get(`${path}/itensPedidos/${uuidPedidoVenda}`, {
        headers: loginService.getHeaders(),
      });
    },
  };
};

export default ConferenciaService;
